import React, { useContext } from "react";
import { convertBlockDataToRicos } from "./../../ricos-content/lib/convertBlockDataToRicos";
import { EditorContext, ModalContext, PluginsEventsContext, RicosContext } from "./../../ricos-context";
import styles from "../statics/styles/giphy-api-input-modal-scss";
import { GiphyApiInputModal } from "../toolbar/giphyApiInputModal";
import { GIPHY_TYPE } from "../types";
const GiphyInsertModal = ({
  componentData,
  nodeId,
  modalId,
  showCloseButton,
  getGiphyUrl
}) => {
  const { t, isMobile, languageDir } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const modalService = useContext(ModalContext) || {};
  const pluginsEvents = useContext(PluginsEventsContext);
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const addBlockWithFocus = (insertBlock) => setTimeout(() => insertBlock(), 50);
  const onGifAdd = (gif) => {
    const editorCommands = getEditorCommands();
    const data = convertBlockDataToRicos(GIPHY_TYPE, { ...componentData, gif });
    let insertGif = () => {
      editorCommands?.insertBlockWithBlankLines(GIPHY_TYPE, data);
    };
    if (nodeId) {
      insertGif = () => {
        editorCommands?.setBlock(nodeId, GIPHY_TYPE, data);
      };
    }
    addBlockWithFocus(insertGif);
  };
  const pluginEvents = {
    onPluginAction: (searchTerm) => pluginsEvents.publishPluginPopoverSearch({ pluginId: GIPHY_TYPE, searchTerm })
  };
  return /* @__PURE__ */ React.createElement("div", { className: styles.modalWrapper }, /* @__PURE__ */ React.createElement(
    GiphyApiInputModal,
    {
      getGiphyUrl,
      componentData,
      t,
      isMobile,
      languageDir,
      onGifAdd,
      onCloseRequested: closeModal,
      helpers: pluginEvents,
      showCloseButton
    }
  ));
};
var InsertModal_default = GiphyInsertModal;
export {
  InsertModal_default as default
};
//# sourceMappingURL=InsertModal.js.map
